import React, { useState } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import CheckIcon from '@mui/icons-material/Check';
import { countries } from '../../utils/countryList';
import { languages } from '../../utils/languageList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CrossIcon } from '../SvgIcon/CommonSvgIcons';

const StyledSelect = styled(Select)`
  & :nth-child(1) {
    cursor: pointer;
  font-family: inherit;
  }
`;

const Label = styled.span`
  width: 100%;
  height: 20px;
  font-family: inherit;
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  margin-left: ${(props) => (props?.showMargin == true ? '0px' : '8px')};
  text-align: left;
  color: #000000;
`;

const SubLabel = styled.span`
  color: #636363;
  display: flex;
  height: 20px;
  font-size: 14px;
  margin-left: ${(props) => (props?.showMargin == true ? '0px' : '8px')};
  font-family: inherit;
`;
const Optiondiv =styled.div`
  text-align: left;
  display: flex;
  padding-left: 15px;
  padding-bottom: 10px;

    &:hover {
    
    background: rgb(240, 255, 240);
  }
`;

const SelectWrapper = styled.div`
  position: relative;
  margin-top:10px;
  & > :last-child {
    position: absolute;
    top: 30%;
    right: 2%;
    pointer-events: none;
  }
`;

const customStyles = (isError) => ({
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    borderRadius: '15px',
    // border: '',
    marginLeft: '0px',
    background: '#FFF',
    minHeight: '54px',
    boxShadow:'none',
    '&:hover': {
      border: '1px solid green', // hover color (e.g., green)
      // background:'rgb(240, 255, 240)',
    },
    border: state.isFocused ? '1px solid green' : isError ? '1px solid red' : '1px solid #A2A2A2',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#636363',
    fontSize: '16px',
    textAlign: 'left',
    marginLeft: '10px',
    fontFamily: 'Inter',
    //fontWeight:'500',
  }),
  option: (provided, state) => ({
    ...provided,
    width: '1518px',
    fontSize: '16px',
    fontWeight: '500',
    fontFamily: 'Inter',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#636363',
  }),
  multiValue: (provided) => ({
    ...provided,
    // backgroundColor: '#F2F2FE',
    background:'rgb(240, 255, 240)',
    borderRadius: '40px',
    width: '90px',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#636363',
  }),
});

const CustomizeMultiSelect = ({
  label,
  placeholder,
  subLabel,
  onChange,
  language,
  value,
  setValue,
  singleSelect = false,
  showMargin = false,
  isError=false,
  setIsErrorList={}
}) => {
  const optionStyle = {
    marginLeft: '5px',
    color: '#707070',
    fontSize: '16px',
    fontWeight: '500',
    marginTop: '12px',
  };

  const IconStyle = {
    width: '25px',
    height: '25px',
    border: '1px solid rgba(152, 152, 152, 0.24)',
    margin: '8px 8px 0px 8px',
    borderRadius: '50%',
    color: '#fff',
    background: '#fff',

    /*  ${({ active }) => active === "false" && "background: #fff"}
  `; */
  };

  const [selectedCountries, setSelectedCountries] = useState([]);

  const handleSelect = (event) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    );
    setSelectedCountries(selectedOptions);
  };
  const handleChange = (selectedCountries) => {
    setValue(selectedCountries || []);
    setIsErrorList(prev => ({
                ...prev,
                selectedNotifyMethod: ''
            }));
    // setSelectedCountries(selectedCountries || []);
    // onChange(selectedCountries);
  };

  const Option = ({ children, isSelected, innerProps }) => (
    <Optiondiv style={{
      
    }} {...innerProps}>
      {/* <CheckIcon active={value} style={IconStyle} isSelected={isSelected} /> */}
      <span style={optionStyle}>{children}</span>
    </Optiondiv>
  );
  console.log(value,"value");
  return (
    <>
      {label && <Label showMargin={showMargin}>{label}</Label>}
      {subLabel && <SubLabel showMargin={showMargin}>{subLabel}</SubLabel>}
      <SelectWrapper>
        <StyledSelect
          options={language}
          onChange={handleChange}
          value={value}
          isMulti={!singleSelect}
          // styles={customStyles}
          styles={customStyles(isError)}
          components={{ Option }}
          placeholder={placeholder}
        />
        {value?.length > 0 ? (
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '8px',
              pointerEvents: 'auto',
            }}
          >
            
          </button>
        ) : (
          <KeyboardArrowDownIcon />
        )}
      </SelectWrapper>
    </>
  );
};

export default CustomizeMultiSelect;
